import React, {useState, useEffect} from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import MainRouter from "../routes/Router";
import {ErrorBoundary} from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';
import Header from "./Header";
import Footer from "./Footer";
import BackToTop from "./BackToTop";
import CookiePopup from "./popups/CookiePopup";
import {
    setBanner,
    setCurrentCategoryData,
    setDefaultCategoryData,
    setMainCategories
} from "../redux/dataUploader/dataSlice";
// import GetConfigCategoriesData from "../hooks/get-config-categories";
// import GetCategoriesData from "../hooks/get-categories";
import { GlobalStateProvider } from "../context/GlobalStateContext";
// import GetLevantaCategoriesData from "../hooks/get-levanta-categories";

const App = () => {
    const [searchTitle, setSearchTitle] = useState('');
    const dispatch = useDispatch();
    let isRenderPopupStorage = localStorage.getItem("isRenderPopup");
    const mainCategories = useSelector(state => state.dataUploader.mainCategories);
    const currentCategoryData = useSelector(state => state.dataUploader.currentCategoryData);
    const defaultCategoryData = useSelector(state => state.dataUploader.defaultCategoryData);
    const [categoriesList, setCategoriesList] = useState([]);
    const [isRenderPopup, setRenderPopup] = useState(null);
    const [isVisiblePopup, setVisiblePopup] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let isRenderPopupStorageCopy = isRenderPopupStorage;
        if (isRenderPopupStorageCopy === null) {
            localStorage.setItem("isRenderPopup", '1');
            isRenderPopupStorageCopy = '1';
        }

        if (Number(isRenderPopupStorageCopy)) {
            setRenderPopup(true);
            setTimeout(() => {
                setVisiblePopup(true);
            }, 2000)
        } else {
            setRenderPopup(false);
            setVisiblePopup(false);
        }

    }, [isRenderPopupStorage]);

    useEffect(() => {
        const handleSmoothScroll = (e) => {
            if (e.target.classList.contains('smoth-animation')) {
                e.preventDefault();
                const target = document.querySelector(e.target.getAttribute('href'));
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
            }
        };

        document.addEventListener('click', handleSmoothScroll);
        return () => document.removeEventListener('click', handleSmoothScroll);
    }, []);

    const handleVisibleCookiePopup = () => {
        localStorage.setItem("isRenderPopup", '0');
        setVisiblePopup(false);
    };

    return (
        <Router>
            <GlobalStateProvider>
                <ErrorBoundary FallbackComponent={ErrorFallback}>
                    <Header 
                        data={categoriesList}
                        setSearchTitle={setSearchTitle}
                    />
                    <MainRouter
                        categoriesList={categoriesList}
                        categoriesError={error}
                    />
                    <Footer categoriesList={categoriesList}/>
                    <BackToTop />
                    {isRenderPopup && (
                        <CookiePopup
                            visible={isVisiblePopup}
                            handleVisibleCookiePopup={handleVisibleCookiePopup}
                        />
                    )}
                </ErrorBoundary>
            </GlobalStateProvider>
        </Router>
    )
}

export default App;
